export default function AZFilterIcon(props) {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill={props.fill || "#6CB6E3"}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.3697 6.99062C10.805 6.58989 10.8313 5.91123 10.4297 5.47555L6.14234 0.828995C5.73782 0.390633 4.97323 0.390633 4.56879 0.828995L0.284713 5.47287C-0.117045 5.90846 -0.0905285 6.58708 0.344709 6.98794C0.551213 7.18257 0.811909 7.27632 1.07127 7.27632C1.36004 7.27632 1.64757 7.16052 1.85782 6.93174L4.28533 4.29884V19.4273C4.28533 20.0165 4.76744 20.4986 5.35668 20.4986C5.94593 20.4986 6.42804 20.0183 6.42804 19.4264V4.29884L8.8551 6.93036C9.25374 7.3656 9.93226 7.39684 10.3697 6.99062ZM18.9406 14.008C18.504 13.6031 17.8259 13.6324 17.4273 14.068L14.9989 16.6998V1.57225C14.9989 0.980324 14.5212 0.5 13.9275 0.5C13.3338 0.5 12.8562 0.980324 12.8562 1.57225V16.7007L10.4291 14.0692C10.2184 13.8404 9.93092 13.7246 9.64255 13.7246C9.3831 13.7246 9.12205 13.8181 8.91581 14.0092C8.48057 14.4099 8.45424 15.0885 8.85582 15.5242L13.1011 20.1712C13.5056 20.6096 14.2702 20.6096 14.6746 20.1712L18.9199 15.5242C19.4004 15.0883 19.3736 14.4098 18.9406 14.008Z"
        fill="#6CB6E3"
      />
    </svg>
  )
}
